import React, { useState } from "react";
import AddBoxIcon from "@mui/icons-material/AddBox";
import { ReactComponent as Bell } from "../../assets/icons/bell.svg";
import styled from "styled-components";

import {
  selectBlockRetiro,
  selectCurrency,
  selectGameBalance,
  selectId,
  selectLogged,
  selectNotVerifiedPeru,
  selectToken,
  selectUser,
  selectWithdrawBalance,
  setNewToken,
  updateBalance,
} from "../../features/user/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import axios from "axios";
import { API_URL } from "../../const/api";
import { comprobarTiempoInactivo, formatCurrency, toLocale } from "../../utils/tools";
import { Link } from "react-router-dom";
import { selectDepositModal, setShowUserDepositModal } from "../../features/modals/modalsSlice";
import Swal from "sweetalert2";
import { PRIMARY, SECONDARY } from "../../const/colors";
import { infoNotification } from "../../utils/toastNotifications";
import { selectLimites, setLimites } from "../../features/limitaciones/limitacionesSlice";

const StyledBell = styled(Bell)`
  height: 29px;
  margin: 6px;
`;
const StyledAddBoxIcon = styled(AddBoxIcon)`
  font-size: "large";
  color: #ffce05;
`;
const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;

  padding: 0 5%;
  font-size: 12px;
  font-weight: bold;
`;

const DivSaldo = styled.div`
  cursor: pointer;
  height: 100%;
  font-weight: bold;
  border-radius: 5px;
  padding: 8px;
  display: flex;
  align-items: center;
  gap: 6px;
  box-shadow: inset 0px 0px 5px 0px rgba(255, 206, 5, 0.5);
`;

const TextSpan = styled.span`
  font-size: 16px;
  color: white;
  @media screen and (max-width: 500px) {
    font-size: 12px;
  }
`;

const UserResumeProfile2 = () => {
  const [saldoTotal, setSaldoTotal] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  const user = useSelector(selectUser);
  const moneda = useSelector(selectCurrency);
  const token = useSelector(selectToken);
  const id_uo = useSelector(selectId);
  const isLoged = useSelector(selectLogged);
  const saldo_juego = useSelector(selectGameBalance);
  const saldo_retiro = useSelector(selectWithdrawBalance);

  const notVerifiedPeru = useSelector(selectNotVerifiedPeru);
  const limitaciones = useSelector(selectLimites);

  const blockRetiro = useSelector(selectBlockRetiro)

  const getLimitaciones = async () => {
    let body = { id_uo, token };
    let tiempo_inactivo = ''
    try {
      const res = await axios.post(API_URL + "getLimitaciones", body);
      if (res.data.response !== null) {
        dispatch(setLimites(res.data.response));
        const fecha_config = res.data.response.fecha_config;
        tiempo_inactivo = res.data.response.tiempo_inactivo;

        //validamos si se cumplio el tiempo de inactividad
        if(tiempo_inactivo > 0 && fecha_config && comprobarTiempoInactivo(fecha_config)) {
          // se cumplio el tiempo de inactividad y lo seteamos a 0
          body = {...body, ...limitaciones, tiempo_inactivo: 0, fecha_config: null}
          const res = await axios.post(API_URL + "setLimitaciones", body);
          if(res.data.response==='ok') {
            dispatch(setLimites({...limitaciones, tiempo_inactivo: 0, fecha_config: null}))
          }
        } 
      } 
    } catch (error) {
      //console.log(error);
    }

    return tiempo_inactivo;
  };

  const dispatch = useDispatch();

  useEffect(() => {
    const loadData = async () => {
      const resMonto = await axios.post(API_URL + "actualizarMonto", {
        token,
        id_uo,
      });
      dispatch(setNewToken(resMonto.data.token));
      if (resMonto.data.status === 1) {
        const {
          saldo_juego,
          saldo_retiro,
          saldo_bonos,
          validacion_documento,
          personalDocument,
          verified
        } = resMonto.data.response;
        dispatch(
          updateBalance({
            saldo_juego,
            saldo_retiro,
            saldo_bonos,
            validacion_documento,
            personalDocument,
            verified
          })
        );
        setSaldoTotal(parseFloat(saldo_juego) + parseFloat(saldo_retiro));
      }
    };
    loadData();
  }, []);

  useEffect(() => {
    if (isLoged) {
      setSaldoTotal(parseFloat(saldo_juego) + parseFloat(saldo_retiro));
    }
  }, [isLoged, saldo_juego, saldo_retiro]);

  const handleOpenDepositModal = () => {

    if (limitaciones.tiempo_inactivo<=0) {
      setModalOpen(!modalOpen);
      dispatch(setShowUserDepositModal({ open: !modalOpen, type: false }));
    }

    if(isLoged && modalOpen===false && limitaciones.tiempo_inactivo>0) {
      const tiempo = getLimitaciones();
      if(limitaciones.tiempo_inactivo>0) {
        infoNotification("Su cuenta se encuentra inactiva por indicaciones del usuario.")
      } 
    }

    //dispatch(setShowUserDepositModal({ open: !modalOpen, type: false }));
  };
  const scrolltop = () =>{
    const scrollscrolltop = document.getElementById("root");
    scrollscrolltop.scrollIntoView({ behavior: "smooth" });
  }
  return (
    <Container>
      <div onClick={scrolltop}>
        <Link to="/notificaciones">
          <StyledBell />
        </Link>
      </div>
      <DivSaldo onClick={handleOpenDepositModal}>
        <TextSpan>{toLocale(parseFloat(saldoTotal))}</TextSpan>
        <TextSpan>{formatCurrency(moneda, user)} </TextSpan>
        <StyledAddBoxIcon fontSize="large" />
      </DivSaldo>
    </Container>
  );
};

export default UserResumeProfile2;
